import React 				from 'react';
import ReactDOM 			from 'react-dom';
import Masonry 				from 'react-masonry-component';
import BLComponent			from '../core/_BLComponent.jsx';
import StudioModel			from './StudioModel.jsx';
import {StudioEvents}			from './_StudioEvents.jsx';
import MocCard 				from '../common/_MocCard.jsx';
import EmptyState 			from '../common/_EmptyState.jsx';
import SimpleProfileCard 	from '../common/_SimpleProfileCard.jsx';

import {CustomAlert}		from '../common/_Utilities.jsx';

export default class PublicStudioGallery extends BLComponent 
{
	constructor (props) 
	{
		super(props);

		this.state = {
			page:			1,
			pageSize:		50,
			category:		0,
			searchQuery:	'',
			filters:		[
								{type: 'published', method: 0}
							,	{type: 'sort', method: 5, direction: 1}
							,	{type: 'visibility', method: 0 }
							],
			view:			0,
			idUser:			parseInt(blapp.util.getUrlVar('idUser')),
			models:			blapp.models.get('models').arrModels,
			totalModels:	blapp.models.get('models').nTotalCnt,
			builder:		blapp.models.get('userBuilder'),
			idModel: 		blapp.util.getUrlVar( 'idModel' ),
			focusSearch: false,
		};

		this.funcUpdateResults	= _.debounce( function ( query ) { this.updateResults( 0 ) }.bind( this ), 1000 );

		this.masonryOptions = {
			transitionDuration: 0
		};
	}

	componentDidMount() 
	{
		this.registerPopStateCallback( ( e ) => this.onPopState( e ) );

		let	cFilters	= blapp.cookie.getLocalStorage( "galleryFilters" );

		if ( cFilters != null && cFilters != "" )
		{
			const arr = cFilters.split(",");
			const filters = [
				{ type: 'published', method: 0 }
			,	{ type: 'sort', method: 5, direction: 1	}
			,	{ type: 'visibility', method: parseInt(arr[3]) || 0 }
			]
			this.setState({filters: filters})
		}
	}	

	getModelAwards(model)
	{
		let awards = []
		if(model.nTypeBadge > 0)
			awards.push(model.nTypeBadge)

		if(model.listEventBadges)
			awards.push(StudioEvents(model.listEventBadges[0]))

		return awards;
	}

	getBuilderAwards(stats)
	{
		let awards = []
		if(stats.nTypeBadge > 0)
			awards.push(stats.nTypeBadge)

		if(stats.nStaffPicked > 0)
		{
			awards.push(6)
		}
			
		if(stats.listEventBadges)
		{
			stats.listEventBadges.forEach(badge => {
				awards.push(StudioEvents(badge))
			})
		}

		return awards;
	}

	render() 
	{
		if(this.state.builder.dmUser == null)
		{
			return(
				<div className="main main--white">
					User not found
				</div>
			)
		}
		else{
			const modelFunc	=	{
				setSearch: (strSearch) => this.updateSearchString(strSearch)
			};

			const mocs = this.state.models.filter(model => model.dmMainImage != null).map((model) => {
				return (
					<MocCard referer={this.state.builder.dmUser.skUsername} classes={this.state.view == 0 ? 'studio-gallery__my-moc-card' : ''} key={model.idModel} data={MocCard.getDataFromModel(model)} withIconBackground awards={this.getModelAwards(model)} func={modelFunc}/>
				);
			});
			
			const isMe = blapp.session.getUserID() == this.state.builder.dmUser.idUser;
			const mocImageUrl = 'https://file.bricklink.com/19/944/944809.F302D0A54A35F2CE.jpg';

			return (
				<div className="main main--white">
					{this.state.idModel != null ? <StudioModel referer={this.state.builder.dmUser.skUsername} idModel={this.state.idModel} close={this.closeDetailModal} func={modelFunc}/>: null}
					<div className="main__content">
						<div className="edge-to-edge-container studio-gallery__my-header" style={{backgroundImage: `url(${mocImageUrl})`}}>
							<div className="edge-to-edge-container__internal studio-gallery__my-header-internal">
								<div>
									<SimpleProfileCard type={'title'} user={this.state.builder.dmUser} awards={this.getBuilderAwards(this.state.builder.stats)} classes="studio-gallery__profile-card"/>
								</div>
								{this.renderUserStats()}
								{isMe && 
									<a className="btn btn--tight btn--white l-flex l-center studio-gallery__my-header-btn" data-ts-name="studio-gallery__my-studio-btn" href={blapp.url2.getStudioMyStudioUrl()}>
										<i className="fas fa-cog"/><span className="l-hide--small l-margin-left--sm">{$T("MY_STUDIO")}</span>
									</a>
								}
							</div>
						</div>
						{this.renderSearchBar()}

						<div className="studio-gallery__nav">
							{this.renderViewTabs()}
						</div>

						{this.renderSearchFilters()}

						<div className="l-full-width overflow-hidden l-pad-y--sm">
							<div className="studio-gallery__card-container">
								{mocs.length ? 
									<Masonry elementType={'div'} options={this.masonryOptions} disableImagesLoaded={false}>
										{mocs}
									</Masonry>
								:
									<EmptyState type="scared" title="It's lonely in here" message={this.state.view == 0 ? `${isMe ? "You haven’t" : `${this.state.builder.dmUser.skUsername} hasn't`} submitted any creations yet.` : `${isMe ? "You haven’t" : `${this.state.builder.dmUser.skUsername} hasn't`} liked anything yet.`}/>
								}
							</div>
						</div>
						<div className="l-flex l-center-v l-margin-top l-margin-bottom--xl">
							{this.state.totalModels > this.state.models.length ? <button className="btn btn--cta l-pad" onClick={() => this.loadMore()}>{$T("LOAD_MORE_CREATIONS")}</button>: null}
						</div>
					</div>
				</div>
			);
		}
	}

	updateFilters(type, method, value) 
	{
		const filters = this.state.filters;
		filters[type][method] = value;

		//let filterStr = `${filters[0].method},${filters[1].method},${filters[1].direction},${filters[2].method}`;
		//blapp.cookie.setLocalStorage( "galleryFilters", filterStr );

		this.setState({filters: filters}, () => this.updateResults(0));
	}

	renderUserStats() {
		return (
			<div className="studio-gallery__user-stats">
				<div className="studio-gallery__stat" data-ts-name="studio-gallery__stat--creations">
					<p className="text--small-title studio-gallery__stat-number">{this.state.builder.stats.nPublicCreations}</p>
					<p><i className="fas fa-lightbulb-on l-margin-right--sm l-hide--small"/>{$T("CREATIONS")}</p>
				</div>
				<div className="studio-gallery__stat">
					<p className="text--small-title studio-gallery__stat-number" data-ts-name="studio-gallery__stat--views">{this.state.builder.stats.nPublicViews}</p>
					<p><i className="fas fa-eye l-margin-right--sm l-hide--small"/>{$T("VIEWS")}</p>
				</div>
				<div className="studio-gallery__stat">
					<p className="text--small-title studio-gallery__stat-number" data-ts-name="studio-gallery__stat--likes">{this.state.builder.stats.nPublicLikes}</p>
					<p><i className="fas fa-star l-margin-right--sm l-hide--small"/>{$T("LIKES")}</p>
				</div>
			</div>
		);
	}

	renderViewTabs() {
		return (
			<ul className="view-selector view-selector--bordered studio-gallery__tabs">
				<li data-ts-name="studio-gallery-tab--creations" className={"view-selector__item" + (this.state.view == 0 ? " view-selector__item--active" : "")} onClick={this.state.view != 0 ? () => this.updateView(0) : null}>
					<span className="view-selector__item-content">{$T("CREATIONS")}</span>
				</li>
				<li data-ts-name="studio-gallery-tab--likes" className={"view-selector__item" + (this.state.view == 1 ? " view-selector__item--active" : "")} onClick={this.state.view != 1 ? () => this.updateView(1) : null}>
					<span className="view-selector__item-content">{$T("LIKES")}</span>
				</li>
			</ul>
		);
	}

	renderSearchFilters() {
		const {method: sortMethod, direction: sortDirection} = this.state.filters[1];
		const {method: publishMethod} = this.state.filters[0];
		const {method: visibility} = this.state.filters[2];

		return (
			<div className="studio-gallery__filters">
				{this.state.searchQuery ? 
					<p className="studio-gallery__results-count" data-ts-name="studio-gallery-results__count">
						{this.state.totalModels} {$T("SEARCH_RESULTS_FOR")} "<strong>{this.state.searchQuery}</strong>"
					</p> 
				: 
					<p className="studio-gallery__results-count" data-ts-name="studio-gallery-results__count">
						<strong>{this.state.totalModels} {this.state.view == 1 ? 'like' : 'creation'}{this.state.totalModels != 1 ? 's' : ''}</strong>
					</p>
				}

				<div className="l-flex l-center studio-gallery__filters-show">
					<p className="l-margin-right--sm">Show:</p>
					<select className="select select--x-tight studio-gallery__filter-item" data-ts-name="studio-gallery-results__filter--show" value={visibility} onChange={(e) => this.updateFilters(2, 'method', e.target.value)}>
						<option value={0}>All designs</option>
						<option value={1}>For display only</option>
						<option value={2}>Downloadable</option>
					</select>
				</div>

				<div className="l-flex l-center studio-gallery__filters-sort">
					<p className="l-margin-right--sm l-hide--small">Sort:</p>
					<div className="sort-lockup studio-gallery__filter-item">
						<button className="btn sort-lockup__direction" data-ts-name="studio-gallery-results__filter--sort-direction" onClick={(e) => this.updateFilters(1, 'direction', sortDirection == 1 ? 2 : 1)}><i className={"fas " + (sortDirection == 1 ? 'fa-sort-amount-down' : 'fa-sort-amount-up')}/></button>
						<select className="select sort-lockup__select" data-ts-name="studio-gallery-results__filter--sort" value={sortMethod} onChange={(e) => this.updateFilters(1, 'method', e.target.value)}>
							<option value={4} selected={sortMethod == 4}>{$T("RECENTLY_LIKED")}</option>
							<option value={1} selected={sortMethod == 1}>{$T("TOTAL_LIKES")}</option>
							<option value={5} selected={sortMethod == 5}>{$T("PUBLISH_DATE")}</option>
							<option value={2} selected={sortMethod ==	2}>{$T("VIEWS")}</option>
							<option value={3} selected={sortMethod == 3}>{$T("DOWNLOADS")}</option>
						</select>
					</div>

					<select className="select select--x-tight l-margin-left bg-color--white text--tight studio-gallery__filter-item" data-ts-name="studio-gallery-results__filter--publish-time" value={publishMethod} onChange={(e) => this.updateFilters(0, 'method', e.target.value)}>
						<option value={1} selected={publishMethod == 1}>{$T("PAST_24")}</option>
						<option value={2} selected={publishMethod == 2}>{$T("PAST_WEEK")}</option>
						<option value={3} selected={publishMethod == 3}>{$T("PAST_MONTH")}</option>
						<option value={0} selected={publishMethod == 0}>{$T("ANYTIME")}</option>
					</select>
				</div>
			</div>
		);
	}

	renderSearchBar() {
		return (
			<div className="studio-gallery__search">
				<div className="search-lockup search-lockup--bordered studio-gallery__search-filter">
					<div className={"search-lockup__input-container" + (this.state.focusSearch ? ' search-lockup__input-container--focus' : '')}>
						<input type="text" className="search-lockup__input search-lockup__input--start" data-ts-name="studio-gallery__search-input" onFocus={() => this.setState({focusSearch: true})} onBlue={() => this.setState({focusSearch: false})} placeholder={$T("SEARCH_CREATIONS", [this.state.builder.dmUser.skUsername])} value={this.state.searchQuery} onChange={(e) => this.updateSearchString(e.target.value)}/>
						{this.state.searchQuery ? 
							<i className="fas fa-times-circle search-lockup__btn--clear" data-ts-name="studio-gallery__search-clear" onClick={() => this.updateSearchString('')}></i> 
						: null}
					</div>
					<button className="search-lockup__btn search-lockup__btn--end" data-ts-name="studio-gallery__search-cta"><i className="far fa-search search-lockup__btn-icon"></i></button>
				</div>
			</div>
		);
	}

	updateView(key)
	{
		this.setState({view: key}, ()=> this.updateResults(0))
	}

	updateSearchString(query)
	{
		if ( query.length <= 3 && query !== '')
		{
			this.setState({searchQuery: query});
		}
		else
		{
			this.setState({searchQuery: query});
			this.funcUpdateResults(query);
		}
	}

	triggerAlert(message) {
		const confirmContent = `<i class="text-color--primaryRed fas fa-exclamation-triangle l-margin-bottom" data-ts-name="alert--error"></i>
		<p class="text-color--primaryRed">${message}</p>`;

		CustomAlert(confirmContent);
	}

	updateResults(option)
	{
		blapp.models.fetch
		(
			"_updatePublicGallerySearch"
		,	{
				controller:	"studio.BLCUserModel"
			,	method:		this.state.view == 0 ? "getModelList" : "getLikedModelList"
			,	params:		[ 
								option == 0 ? 1 : this.state.page + 1,
								this.state.pageSize,
								this.state.filters[1].method,
								this.state.filters[1].direction,
								this.state.filters[0].method,
								this.state.filters[2].method,
								this.state.category,
								this.state.searchQuery.trim(),
								this.state.idUser ]
			,	refresh:	true
			}
		).then(
        	(data) =>
            {
				if(data !== null){
					if(option == 1){
						this.setState(prevState => ({
							models: prevState.models.concat(data.arrModels),
							page: prevState.page + 1,
							totalModels: data.nTotalCnt
						}))
					}
					else{
						this.setState(prevState => ({
							models: data.arrModels,
							page: 1,
							totalModels: data.nTotalCnt
						}))
					}
				}
                else{
					this.triggerAlert('Error loading models')
				}
            }
        ).catch( 
        	() =>
            {
				this.triggerAlert('Error loading models')
            }
        );
	}

	loadMore()
	{
		this.updateResults(1)
	}

	closeDetailModal = () =>
	{
		this.setState({ idModel: null });
	}

	onPopState( e )
	{
		const	urlInfo		= blapp.util.getUrlInfo( window.location.href );
		const	galleryUrl	= blapp.util.getUrlInfo( blapp.url2.getStudioPublicGalleryUrl( 0 ) );
		const	modelUrl	= blapp.util.getUrlInfo( blapp.url2.getStudioModelUrl( 1 ) );

		if ( urlInfo.path == galleryUrl.path )
		{
			this.setState( { idModel: null } );
		}
		else if ( urlInfo.path == modelUrl.path )
		{
			const	idModel	= parseInt( blapp.util.getUrlVar( "idModel" ) );

			if ( idModel > 0 )
				this.setState( { idModel: idModel } );
		}
	}	
};

document.addEventListener("DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<PublicStudioGallery blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-studio-gallery' )
						);
		blapp.refs.register( "main", elem );
	}
);

var $T = BLComponent.createTextMap( 
		{
			"MY_STUDIO":
			{
				"en":	"My Studio"
			,	"kr":	""
			,	"es":	"Mi Studio"
			}
		,	"SEARCH_RESULTS_FOR":
			{
				"en":	"Search results for ",
				"kr":	"",
				"es":	"Busca resultados para "
			}
		,	"LOAD_MORE_CREATIONS":
			{
				"en":	"Load more creations",
				"kr":	"",
				"es":	""
			}
		,	"CREATIONS":
			{
				"en":	"Creations"
			,	"kr":	""
			,	"es":	"Creaciones"
			}
		,	"LIKES":
			{
				"en":	"Likes"
			,	"kr":	""
			,	"es":	"Likes"
			}
		,	"SEARCH_CREATIONS":
			{
				"en":  `Search {{$0}}'s creations or likes`
			,	"kr":  ``
			,	"es":  ``
			}
			,	"RECENTLY_LIKED":
			{
				"en":	"Recently liked"
			,	"kr":	""
			,	"es":	"Gustados recientemente"
			}
		,	"TOTAL_LIKES":
			{
				"en":	"Total likes"
			,	"kr":	""
			,	"es":	"Más gustados"
			}
		,	"PUBLISH_DATE":
			{
				"en":	"Published date"
			,	"kr":	""
			,	"es":	"Fecha de publicación"
			}
		,	"VIEWS":
			{
				"en":	"Views"
			,	"kr":	""
			,	"es":	"Visitas"
			}
		,	"DOWNLOADS":
			{
				"en":	"Downloads"
			,	"kr":	""
			,	"es":	"Descargas"
			}
		,	"PAST_24":
			{
				"en":	"Past 24 hours"
			,	"kr":	""
			,	"es":	"Últimas 24 horas"
			}
		,	"PAST_WEEK":
			{
				"en":	"Past week"
			,	"kr":	""
			,	"es":	"Última semana"
			}
		,	"PAST_MONTH":
			{
				"en":	"Past month"
			,	"kr":	""
			,	"es":	"Último mes"
			}
		,	"ANYTIME":
			{
				"en":	"Any time"
			,	"kr":	""
			,	"es":	"Cualquier momento"
			}
		,	"SORT_BY":
			{
				"en":	"Sort by:",
				"kr":	"",
				"es":	"Ordenar por:"
			}	
		,	"PUBLISHED":
			{
				"en":	"Published:",
				"kr":	"",
				"es":	"Publicado:"
			}	
		
	}
);
 

